import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './rich-text-editor.css';

const DEFAULT_MODULES = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        ['blockquote', 'code-block'],
        ['link', 'image'],
        [{ color: [] }, { background: [] }],
        ['clean'],
    ],
    clipboard: { matchVisual: false },
};

const DEFAULT_FORMATS = [
    'header', 'bold', 'italic', 'underline', 'strike',
    'list', 'align', 'blockquote', 'code-block',
    'link', 'image', 'color', 'background',
];

export function RichTextEditor({ value, onChange, placeholder, minHeight = 220, testId, readOnly = false }) {
    return (
        <div className="dg-rte-wrapper" data-testid={testId} style={{ minHeight }}>
            <ReactQuill
                theme="snow"
                value={value || ''}
                onChange={(html) => onChange && onChange(html)}
                modules={DEFAULT_MODULES}
                formats={DEFAULT_FORMATS}
                placeholder={placeholder || 'Write rich product description here…'}
                readOnly={readOnly}
            />
        </div>
    );
}

export default RichTextEditor;
